// @flow

import {validateAction} from './utils/validate-action';
import {
    UNSUPPORTED_DOWNLOAD_API,
    UNSUPPORTED_PRINT_API,
    UNSUPPORTED_UPLOAD_API,
    CALL_API,
    DOWNLOAD_FILE,
    PRINT_FILE,
    UPLOAD_FILE
} from './constants';
import {callApi as defaultCallApi} from './call-api';

import type {Store as ReduxStore} from 'redux';
import type {Dispatch, ApiAction, ApiDispatch, DownloadFile, PrintFile, CallApi, UploadFile, Action} from './typedef';

type Params = {
    callApi?: CallApi,
    printFile?: PrintFile,
    downloadFile?: DownloadFile,
    uploadFile?: UploadFile,
    apiRoot: string | null,
};

type Middleware = (params: Params) =>
    (store: ReduxStore<*, *>) =>
        (next: Dispatch<*> | ApiDispatch<*>) =>
            (action: Action<*, *> | ApiAction<*, *>) =>
                Promise<*>;

const middleware: Middleware = params => store => next => action => {
    let callFunc, callName;
    const {
        callApi = defaultCallApi,
        printFile = UNSUPPORTED_PRINT_API,
        downloadFile = UNSUPPORTED_DOWNLOAD_API,
        uploadFile = UNSUPPORTED_UPLOAD_API
    } = params;
    const apiRoot = params.apiRoot || '';
    if (action[CALL_API]) {
        callName = CALL_API;
        callFunc = callApi;
    } else if (action[PRINT_FILE]) {
        callName = PRINT_FILE;
        callFunc = printFile;
    } else if (action[DOWNLOAD_FILE]) {
        callName = DOWNLOAD_FILE;
        callFunc = downloadFile;
    } else if (action[UPLOAD_FILE]) {
        callName = UPLOAD_FILE;
        callFunc = uploadFile;
    } else {
        return next(action);
    }

    const callInfo = action[callName];

    function actionWith(data: Object) {
        const finalAction = {...action, ...data};
        delete finalAction[callName];
        return finalAction;
    }

    validateAction(callInfo);

    const [requestType] = callInfo.types;
    next(actionWith({type: requestType}));

    return callFunc(callInfo, apiRoot, store).then((response: any) => {
        return next(actionWith({
            types: callInfo.types,
            ...response
        }));
    });
};

export default middleware;

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
